import {
  ScOptions,
  ScSelectBlock,
  ScSelectButton,
} from 'components/form/primitives/styled';
import { device } from 'components/styles/MediaQuery';
import styled from 'styled-components';

export const ScPaymentsMethods = styled.div`
  padding: 8px 16px 0 16px;
  margin: 0 -16px 0 -16px;
  color: ${({ theme }) => theme.whiteColor};
  @media (${device.mobile}) {
    width: 100%;
    padding: 0;
    margin: 0;
  }
  .crypto-title {
    margin-top: 16px;
  }
  @media (${device.mobile}) {
    padding-bottom: 0;
  }
  ${ScSelectBlock} {
    .custom-label {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
    .limits-wrapper {
      .limits {
        color: ${({ theme }) => theme.whiteColor};
      }
    }
    ${ScOptions} {
      .options-list {
        li {
          &:not(.active) {
            div {
              color: ${({ theme }) => theme.grayColor1};
            }
          }
          &.active {
            div {
              color: ${({ theme }) => theme.whiteColor};
            }
          }
        }
      }
    }
    .limits {
      padding-right: 8px;
      font-weight: 400;
    }
    .options-list {
      gap: 4px;
      .active {
        color: ${({ theme }) => theme.whiteColor};
      }
    }
    .options-list li.active {
      color: ${({ theme }) => theme.whiteColor};
    }
    .options-list > li {
      padding: 0;
    }
    .options-list ul li {
      padding: 2px;
    }
    .value {
      width: 100%;
      display: flex;
      justify-content: space-between;
    }
    ${ScSelectButton} {
      padding: 0 16px 0 8px;
    }
  }
  & .title {
    display: none;
    @media (${device.mobile}) {
      display: block;
    }
  }
  h3 {
    font-size: 16px;
    line-height: 28px;
    font-weight: 700;
    letter-spacing: 0.16px;
    text-transform: none;
    margin-bottom: 16px;
  }

  & .mobile-payments-wrapper {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;

    & .button-wrapper {
      width: 100%;
      button {
        width: 100%;
      }
    }
  }
`;

export const ScPayments = styled.div<{ expanded?: boolean }>`
  display: grid;
  grid-template-columns: repeat(2, 132px);
  gap: 8px;
  position: relative;
  height: 100%;
  overflow: hidden;
  max-height: ${({ expanded }) => (expanded ? '56px' : '1000px')};

  @media (${device.mobile}) {
    grid-template-columns: repeat(3, minmax(140px, 1fr));
  }
  @media (${device.mobileS}) {
    grid-template-columns: repeat(2, minmax(140px, 1fr));
  }
  button {
    display: flex;
    position: relative;
    width: 100%;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    border-radius: 12px;
    background: ${({ theme }) => theme.whiteColor};
    border: none;
    &::before {
      content: '';
      position: absolute;
      inset: 0;
      background: ${({ theme }) => theme.grayColor2};
      opacity: 0.6;
      z-index: 1;
      transition: opacity 0.3s;
      border-radius: 12px;
    }

    &.active::before {
      opacity: 0;
    }

    cursor: pointer;
    height: 56px;
    transition: 0.3s;

    @media (hover: hover) {
      &:hover::before {
        opacity: 0;
      }

      &:hover {
        background: ${({ theme }) => theme.whiteColor};
      }
    }

    &.active {
      border: ${({ theme }) => `2px solid ${theme.greenColor}`};
      background: ${({ theme }) => theme.whiteColor};
    }
  }
`;
